import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import Report, { type UpdateResult } from './Report';

export default function UpdatePanel({ onLogout }: { onLogout: () => void }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<UpdateResult | null>(null);

  async function update() {
    setLoading(true);
    setResult(null);
    try {
      const res = await fetch('/update', { method: 'POST' });
      if (res.status === 401) { onLogout(); return; }
      setResult(await res.json());
    } finally {
      setLoading(false);
    }
  }

  async function logout() {
    await fetch('/logout');
    onLogout();
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Button variant="contained" onClick={update} loading={loading}>
          Обновить базу знаний
        </Button>
        <Button variant="text" size="small" color="inherit" onClick={logout} sx={{ color: 'text.secondary' }}>
          Сменить токен
        </Button>
      </Box>
      {result && <Report data={result} />}
    </Box>
  );
}
